import { hideLoader } from "action/loader/hideLoader";
import { showLoader } from "action/loader/showLoader";
import { closeModal } from "action/modal/closeModal";
import PAChatWidgetIcon from "component/anchor-top/PAChatWidgetIcon";
import AppContainer from "container/app.container";
import axios from "fetch-api/fetch-api";
import { appWithTranslation } from "next-i18next";
import App from "next/app";
import { withRouter } from "next/router";
import qs from "query-string";
// import "raf/polyfill";
import { connect } from "react-redux";
import HideIf from "util/HideIf";
import { isBusinessHP } from "util/helper/helper";
import {
  isLoginPage,
} from "util/url/checkRouteInclude";
import "../../partsavatar-base.css";
import "../../partsavatar-defer.css";
// import "../../tailwind.css";
import { setGoogleReviewSummary } from "action/auth/setGoogleReviewSummary";
import { getGoogleReviewSummary } from "api/get-google-review-summary.api";
import "react-loading-skeleton/dist/skeleton.css";
import "styles/css/bootstrap-grid.css";
import "styles/css/bootstrap.css";
import "styles/css/breadcrumb.css";
import "styles/css/button.css";
import "styles/css/common.css";
import "styles/css/display.css";
import "styles/css/font-awesome.css";
import "styles/css/font.css";
import "styles/css/garage-dropdown.css";
import "styles/css/header.css";
import "styles/css/margin-padding.css";
import "styles/css/modal.css";
import "styles/globals.css";
import { getDeviceWidth } from "util/helper/getDeviceWidth";
import nextI18NextConfig from "../../next-i18next.config";
import { setDeviceWidth } from "../action/utils/setDeviceWidth";
import { translateFilters } from "../api/category/translateFilters";
import { wrapper } from "../store";
import { getFilters } from "../util/helper/getFilters";
import isSpecialHoliday from "../util/helper/isSpecialHoliday";
import PASentry from "../util/pa-sentry";
import { getHrefAndPath } from "../util/url/getHrefAndPath";
import { getOrderedQuery } from "../util/url/getOrderedQuery";

class MyApp extends App {
  constructor(props: any) {
    super(props);
    const { router } = props;
    const { locale } = router;
    this._locale = locale;
    axios.init({ locale });
    this.routeStart = this.routeStart.bind(this);
    this.routeEnd = this.routeEnd.bind(this);
    this.state = { previousRoute: "" };
  }

  static getInitialProps = wrapper.getInitialPageProps((store) => async ({ ctx, Component, router }) => {
    let pageProps = {};
    const { width } = store.getState().utils;

    let isUnsecure = false;
    if (!process.browser) {
      isUnsecure = ctx.req?.headers?.["x-forwarded-proto"] === "http";
      try {
        const { req, res } = ctx;
        const { locale } = router;

        const acceptLang = req.headers["accept-language"] || "en";
        // Redirect to french pageshould not happen during Link navigation or router.push
        if (acceptLang.indexOf("fr") === 0 && locale !== "fr" && !req.url.includes("/_next/data")) {
          const queryString = req.url.split("?")[1];
          if (!queryString) {
            res.writeHead(307, { Location: `/fr${req.url}` });
            res.end();
            return {};
          }
          const query = qs.parse(queryString);
          const apiBody = getFilters(query);
          const { data } = await translateFilters(apiBody, "fr");
          const filters = query;
          Object.keys(data).forEach((key) => {
            if (data[key]) {
              filters[key] = data[key];
            }
          });
          const orderedQuery = getOrderedQuery(filters);
          let asPath = `/fr${req.url.split("?")[0]}`;
          if (orderedQuery) {
            asPath += `?${orderedQuery}`;
          }
          res.writeHead(307, { Location: asPath });
          res.end();
          return {};
        }
      } catch (err) {
        console.log(err);
      }
    }

    if (process.browser) {
      if (width !== window.innerWidth) {
        store.dispatch(setDeviceWidth(window.innerWidth));
      }
    } else {
      store.dispatch(setDeviceWidth(getDeviceWidth(ctx.req.headers)));
      try {
        const { data } = await getGoogleReviewSummary();
        store.dispatch(setGoogleReviewSummary(data));
      } catch (err) {
        store.dispatch(setGoogleReviewSummary({
          averageRating: 4.5,
          totalReviewCount: 20061,
        }));
        // PASentry.logException(new Error("Google review summary API failed"), null, { err });
      }
    }

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    if (ctx.res) {
      ctx.res.setHeader("x-frame-options", "SAMEORIGIN");
      // cache static pages
      if (ctx.asPath === ctx.pathname) {
        // console.log("--------------------------- cached ", ctx.asPath);
        ctx.res.setHeader("cache-control", "max-age=2592000"); // one month
      }
    }

    if (Object.keys(pageProps).length > 0) {
      return { pageProps: { ...pageProps, isUnsecure } };
    }
    return { pageProps: { isUnsecure } };
  });

  componentDidUpdate() {
    const { locale } = this.props.router;
    if (this._locale !== locale) {
      this._locale = locale;
      axios.init({ locale });
    }
  }

  componentDidCatch(error: any, errorInfo: any) {
    PASentry.logException(error, errorInfo);
    // Removed in NextJS 11
    // super.componentDidCatch(error, errorInfo);
  }

  routeStart(url:string) {
    this.props.showLoader();
    const previousPath = this.props.router?.asPath?.split("?")?.[0];
    this.setState({ previousRoute: previousPath });

    if (url.includes("/blog/") && typeof window !== "undefined") {
      window.location.href = url;
    }
  }

  routeEnd() {
    this.props.hideLoader();
    if (this.state.previousRoute !== this.props.router?.asPath?.split("?")?.[0]) {
      this.props.closeModal();
    }
  }

  componentDidMount() {
    const { router } = this.props;

    if (process.browser) {
      // Show & hide loaders on route start & end respectively.
      // https://github.com/vercel/next.js/blob/canary/examples/with-loading/pages/_app.js
      router.events.on("routeChangeStart", this.routeStart);
      router.events.on("routeChangeComplete", this.routeEnd);
      router.events.on("routeChangeError", this.routeEnd);

      // const { width } = utils;
      // if (width !== window.innerWidth) {
      this.props.setDeviceWidth(window.innerWidth);
      // }

      router.beforePopState(({ url, as }) => {
        window.isBack = true;

        // isBack is a boolean to check whether user has clicked browser back.
        // It's used to maintain scroll position while clicking browser back button
        window.isBack = true;
        const { href } = getHrefAndPath({
          queryString: as.split("?")[1], href: url, asPath: as,
        });
        router.push(href, as);
        return false;
      });
    }
  }

  componentWillUnmount() {
    const { router } = this.props;
    router.events.off("routeChangeStart", this.routeStart);
    router.events.off("routeChangeComplete", this.routeEnd);
    router.events.off("routeChangeError", this.routeEnd);
    router.beforePopState(() => true);
  }

  render() {
    const { Component, pageProps, router } = this.props;
    const { pathname, asPath } = router;
    const isBusinessPage = isBusinessHP(asPath);
    const isSignInPage = isLoginPage(pathname);

    return (
      // No need to use <Provider> for accessing Redux store because wrapper will do that accordingly.
      // Refer to https://stackoverflow.com/questions/70426965/how-to-use-next-redux-wrapper-with-next-js-redux-toolkit-and-typescript-p
      <AppContainer isUnsecure={pageProps.isUnsecure}>
        <HideIf show={!this.props.businessCustomer && !isBusinessPage && !isSignInPage}>
          <HideIf show={!isSpecialHoliday && !this.props.businessCustomer && !isBusinessPage && !isSignInPage}>
            <PAChatWidgetIcon />
          </HideIf>
        </HideIf>
        <Component {...pageProps} />
      </AppContainer>
    );
  }
}

const mapStateToProps = ({ authenticationState }) => ({
  businessCustomer: authenticationState.businessCustomer,
  authRefreshStatus: authenticationState.refreshStatus,
});

const mapDispatchToProps = (dispatch) => ({
  showLoader: () => dispatch(showLoader()),
  hideLoader: () => dispatch(hideLoader()),
  closeModal: () => dispatch(closeModal()),
  setDeviceWidth: (width: number) => dispatch(setDeviceWidth(width)),
});

export default wrapper.withRedux(connect(mapStateToProps, mapDispatchToProps)(withRouter(appWithTranslation(MyApp, nextI18NextConfig))));
